import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { ROOM_TYPE } from './RoomsContainer.js';
import { Trans, translate } from 'react-i18next';
import { USER_TYPE } from '../../App.js';
import { compose } from 'recompose';
import axios from 'axios';
import Tag from '../../components/Tag/index.jsx';
import HorasReservaciones from '../../components/Balance/HorasReservaciones';

let cancelToken;
let state;
let tokenSession;

class Room extends Component {

  getInitState = () => {
    return {
      SaldoTotal: "",
      TotalHrsChicas: "",
      TotalHrsChicasDisponibles: "",
      TotalHrsGrandes: "",
      TotalHrsGrandesDisponibles: "",
      TotalHrsEspecialesGrandesDisponibles: "",
      TotalHrsEspecialesChicasDisponibles: "",
      hrsChicasUtilizadas: "",
      hrsGrandesUtilizadas: "",
      hrsEspecialesGrandesUtilizadas: "",
      hrsEspecialesChicasUtilizadas: ""
    }
  }

  constructor(props) {
    super(props);
    if (tokenSession != props.getTokenSession) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    if (this.props.getTokenSession) {
      this.getProfile({
        token_id: this.props.getTokenId(),
        token_session: this.props.getTokenSession()
      });
    }
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession ? this.props.getTokenSession() : null;
  }

  getProfile = (params) => {
    this.props.post(
      "/getProfileUser",
      params,
      (response) => this.didGetProfile(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didGetProfile = (response) => {
    this.getHours({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      empresa_id: response.empresa_id
    });
  }

  getHours = (params) => {
    this.props.post(
      "/gethours",
      params,
      (response) => this.didGetHours(response),
      (error) => this.handleErrorHoursResponse(error),
      cancelToken
    );
  }

  didGetHours = (response) => {
    this.setState({
      SaldoTotal: response.SaldoTotal,
      TotalHrsChicas: response.TotalHrsChicas,
      TotalHrsChicasDisponibles: response.TotalHrsChicasDisponibles,
      TotalHrsGrandes: response.TotalHrsGrandes,
      TotalHrsGrandesDisponibles: response.TotalHrsGrandesDisponibles,
      TotalHrsEspecialesGrandesDisponibles: response.TotalHrsEspecialesGrandesDisponibles,
      TotalHrsEspecialesChicasDisponibles: response.TotalHrsEspecialesChicasDisponibles,
      hrsChicasUtilizadas: response.hrsChicasUtilizadas,
      hrsGrandesUtilizadas: response.hrsGrandesUtilizadas,
      hrsEspecialesGrandesUtilizadas: response.hrsEspecialesGrandesUtilizadas,
      hrsEspecialesChicasUtilizadas: response.hrsEspecialesChicasUtilizadas
    })
  }

  getPaymentLink = () => {
    const reservationId = this.props.location.state.reservationId;
    return {
      pathname: (this.props.user.no_account ? "/store" : "") + "/reservations/" + reservationId + "/payment",
      state: {
        center: this.props.location.state.center,
        reservationId: reservationId,
        room: this.props.location.state.room
      }
    };
  }

  renderService = (service, index) => {
    return (
      <li key={index}>{service.name}</li>
    );
  }

  render() {
    // const user = this.props.user;
    if (this.props.location.state === undefined) {
      this.props.history.replace('/reservations');
      return null;
    }

    const center = JSON.parse(this.props.location.state.center);
    const room = JSON.parse(this.props.location.state.room);
    const mapUrl = new URL(`https://www.google.com/maps/search/?api=1&query=${center.name}`);
    // const count = room.capacity;
    const { t } = this.props;

    // let price;

    // switch (room.room_type) {
    //   case ROOM_TYPE.COWORK:
    //     price = t('dashboard.reservations.currency');
    //     break;
    //   default:
    //   case ROOM_TYPE.MEETING_ROOM:
    //     price = t('dashboard.reservations.price');
    //     break;
    // }

    return (
      <div className='container'>
        <div className="content-resvations">
          <div className="">
            <div className="">
              <br />
              <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
            </div>
            <br />
            {this.props.user.memberId
              ? (
                <div className='contHoras2 form-group'>
                  <HorasReservaciones
                      tipoDeSala = {t('dashboard.reservations.big_remaining')}
                      horasDisponibles = { this.state.TotalHrsGrandesDisponibles || 0 }
                      horasUsadas = { this.state.hrsGrandesUtilizadas || 0 }
                  >
                  </HorasReservaciones>
                  <HorasReservaciones
                      tipoDeSala = {t('dashboard.reservations.special_big_remaining')}
                      horasDisponibles = { this.state.TotalHrsEspecialesGrandesDisponibles || 0 }
                      horasUsadas = { this.state.hrsEspecialesGrandesUtilizadas || 0 }
                  >
                  </HorasReservaciones>
                  <HorasReservaciones
                      tipoDeSala = {t('dashboard.reservations.small_remaining')}
                      horasDisponibles = { this.state.TotalHrsChicasDisponibles || 0 }
                      horasUsadas = { this.state.hrsChicasUtilizadas || 0 }
                  >
                  </HorasReservaciones>
                  <HorasReservaciones
                      tipoDeSala = {t('dashboard.reservations.special_small_remaining')}
                      horasDisponibles = { this.state.TotalHrsEspecialesChicasDisponibles || 0 }
                      horasUsadas = { this.state.hrsEspecialesChicasUtilizadas || 0 }
                  >
                  </HorasReservaciones>
              </div>
              )
              : null
            }
          </div>
          <div className="container-room">
            <div className="container-room-header card-panel panel panel-default card">
              <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + room.picture + "')" }}>
              </div>
              <div className="card-panel-body row">
                <section className="container-room-title col-md-6">
                  <div className="panel-body-title">
                      <h4 className="ioscentro">{center.name}</h4>
                    <h4 className="iossala">{room.name}</h4>
                  </div>
                  <div className="panel-body-description">
                    <div className="text-left">
                      {room.description}
                    </div>
                    <div className="flex-tags flex-tags__big">
                      <Tag
                          isBigTag
                          icon='people-group'
                          text={t("venta_linea.reservation_tags.capacity")}
                          value={`${room.capacity} personas`}
                        />
                    </div>
                    <div className="contenedor-flexbox">
                      {this.props.user.balance === undefined
                        ? (<div className="contenedor">
                          <i className="fa fa-usd" aria-hidden="true"></i>
                          {t('dashboard.reservations.price') + " $" + room.price}
                        </div>)
                        : (null)
                      }
                    </div>

                  </div>
                </section>
                <div className="container-room-description col-md-6">
                  <h4 className="page-header text-primary">
                    <strong>{t('dashboard.reservations.heading_services')}</strong>
                  </h4>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <strong>{t('dashboard.reservations.heading_included')}</strong>
                      </p>
                      <section className='flex-tags'>
                        {room.services.map((service, index) =>
                          <Tag key={index} id={service.id} text={service.name} />
                        )}
                      </section>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <strong>{t('dashboard.reservations.heading_extras')}</strong>
                      </p>
                      <section className='flex-tags'>
                        {room.extras.map((service, index) =>
                          <Tag key={index} id={service.id} text={service.name} />
                        )}
                      </section>
                    </div>
                  </div>
                </div>
                <section className='row'>
                  <div className="container-direction mapa col-md-6">
                    <div className="iframe-wrapper">
                      <iframe
                        frameBorder="0"
                        src={
                          "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                          + center.latitude
                          + "%2C"
                          + center.longitude
                        }
                        title={t('dashboard.reservations.frame_center')}>
                      </iframe>
                    </div>
                  </div>
                  <div className="container-room-direction text col-md-6">
                    <h4 className="page-header text-primary">
                      <strong>{t('dashboard.reservations.heading_address')}</strong>
                    </h4>
                    <a href={mapUrl} target='_blank'>
                      <strong>{center.name}</strong>
                      {center.address ? (
                        center.address.split(",").map((row, index) =>
                          <span key={index} style={{ textTransform: "capitalize" }}>
                            <br />
                            {row.toLowerCase()}
                          </span>
                        )
                      ) : (
                        null
                      )}
                    </a>
                  </div>
                </section>
                <div className="panel-body-bottom">
                  <div className="panel-body form-group">
                    <Link to={this.getPaymentLink()}>
                      <button
                        className="btn btn-block btn-primary"
                        type="button">
                        {t('dashboard.reservations.btn_pay')}
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(Room);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/Room.js